// Los valores del cortejo vienen de types (sin zod): settings arrastraría zod
// al bundle del invitado — la trampa documentada del sobre digital.
import { PARTY_KINDS, PARTY_KIND_LABELS } from '@shared/types'
import type { WeddingSettings } from '@shared/settings'
import { Seccion, tieneTexto } from './comunes'

/* ===========================================================================
   El cortejo — quienes cargan los anillos, las arras, la Biblia y el lazo.
   En una boda cristiana latinoamericana no son decoración: tienen rol.

   Se agrupa por tipo (padrinos, damas, pajes…) en el orden fijo de
   PARTY_KINDS. Solo el grupo de padrinos se reparte por lado; los demás son
   listas simples de nombre y papel.
   =========================================================================== */

type Miembro = WeddingSettings['party'][number]

export function hayPadrinos(party: WeddingSettings['party']): boolean {
  return party.some((m) => tieneTexto(m.name))
}

const LADOS: Array<{ side: Miembro['side']; titulo: string }> = [
  { side: 'novia', titulo: 'De parte de la novia' },
  { side: 'novio', titulo: 'De parte del novio' },
]

function Nombres({ miembros }: { miembros: Miembro[] }) {
  return (
    <ul className="mt-4 flex flex-col gap-3">
      {miembros.map((miembro) => (
        <li key={miembro.id}>
          <p className="font-display text-lg leading-snug text-tinta">{miembro.name}</p>
          {tieneTexto(miembro.role) && (
            <p className="mt-0.5 text-sm text-palo-hondo">{miembro.role}</p>
          )}
        </li>
      ))}
    </ul>
  )
}

export default function Padrinos({ party }: { party: WeddingSettings['party'] }) {
  const miembros = party.filter((m) => tieneTexto(m.name))
  const grupos = PARTY_KINDS.map((kind) => ({
    kind,
    integrantes: miembros.filter((m) => m.kind === kind),
  })).filter((grupo) => grupo.integrantes.length > 0)

  return (
    <Seccion id="padrinos" eyebrow="Padrinos y madrinas" titulo="Quienes nos acompañan">
      <div className="flex flex-col gap-10">
        {grupos.map((grupo) => (
          <div key={grupo.kind}>
            <h3 className="eyebrow border-b border-palo/70 pb-3">
              {PARTY_KIND_LABELS[grupo.kind]}
            </h3>
            {grupo.kind === 'padrinos' ? (
              /* auto-fit: si solo un lado tiene padrinos, ese grupo llena la
                 columna en vez de dejar media rejilla muerta. */
              <div className="grid gap-x-8 sm:grid-cols-[repeat(auto-fit,minmax(16rem,1fr))]">
                {LADOS.map((lado) => {
                  const delLado = grupo.integrantes.filter((m) => m.side === lado.side)
                  if (delLado.length === 0) return null

                  return (
                    <div key={lado.side} className="mt-4">
                      <h4 className="text-sm font-medium text-palo-hondo">{lado.titulo}</h4>
                      <Nombres miembros={delLado} />
                    </div>
                  )
                })}
              </div>
            ) : (
              <Nombres miembros={grupo.integrantes} />
            )}
          </div>
        ))}
      </div>
    </Seccion>
  )
}
